import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, isFinalSubmitting, setIsFinalSubmitting, history }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr className="tr-info">
                                <td colSpan={2} className="">
                                    <p className="text-left">
                                        <b>NNNN : </b>Serial Number starting from 0001
                                    </p>
                                </td>
                                <td colSpan={1} className="">
                                    <p className="text-right">
                                        Fill in <b>NA</b> if any field is not applicable
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w300">
                                    <p>(P) VO Reference to</p>
                                </td>
                                <td className="hd-s1 pd10">
                                    <p />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">1.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Contract Clause</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.contract_clause.name}
                                        value={state.contract_clause.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">2.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Specification reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.specification_reference.name}
                                        value={state.specification_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">3.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Drawing No

</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.drawing_number.name}
                                        value={state.drawing_number.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                           
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">4.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Standards Reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.standard_reference.name}
                                        value={state.standard_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">5.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Other (please specify)

</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.other.name}
                                        value={state.other.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">7.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Estimated Cost Impact</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.estimated_cost_impact.name}
                                        value={state.estimated_cost_impact.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">8.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Estimated Time Impact


                                    </p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.estimated_time_impact.name}
                                        value={state.estimated_time_impact.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="td-s1">
                                    <p className="s1">9.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Other Possible consequenses



                                    </p>
                                </td>
                                <td className="tb-input-value">
                                     <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.other_possible_consequenses.name}
                                        value={state.other_possible_consequenses.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>

                           
                        </tbody>
                    </table>

                    <div className="row">
                        <div className="col-lg-12">
                            <table className="mrt20">
                                <tbody>
                                    <tr>
                                        <td className="hd-b">
                                            <p>DESCRIPTION</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="input-textarea">
                                            <textarea
                                                name={state.description.name}
                                                value={state.description.value}
                                                onChange={onChange}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <table className="table-bottom-sig">
                            <tbody>
                                <tr className="bottom-sig-tr2-box">
                                    <td className="input-td">
                                        <p className="s2">Approved by (Owner rep name):

:</p>
                                    </td>
                                    <td>
                                        <p className="s1">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </p>
                                    </td>
                                </tr>
                                <tr className="bottom-sig-tr2-box">
                                    <td className="input-td">
                                        <p className="s2">Date of approval:

:</p>
                                    </td>
                                    <td>
                                        <p className="s1">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </p>
                                    </td>
                                </tr>
                                 <tr className="bottom-sig-tr2-box">
                                    <td className="input-td">
                                        <p className="s2">Cost Impact:

:

:</p>
                                    </td>
                                    <td>
                                        <p className="s1">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </p>
                                    </td>
                                </tr>
                                 <tr className="bottom-sig-tr2-box">
                                    <td className="input-td">
                                        <p className="s2">Time Impact:

:

:</p>
                                    </td>
                                    <td>
                                        <p className="s1">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                defaultValue=""
                                            />
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="tr-info mt-4">
                    <p className="text-left" style={{ color: "rgb(0, 119, 226)" }}>
                        NOTE: Enter date of approval/ cost impact/ time impact as above in Variation Order Index/ Register


                    </p>
                </div>
                <div class="final-checkbox">
                    <div class="form-check">
                        <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                        <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.siteManagement.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)